 <div style="height: 90vh;" id="inparticipe">

<mat-drawer-container  class="invoices-container" style="height: 90vh;z-index: 1!important;" autosize>
  <mat-drawer   mode="side" opened>
    <button mat-raised-button (click)="createNew()">
      <mat-icon>add</mat-icon> New Invoice
    </button>
    <button mat-raised-button *ngIf=" selectedInvoice && !selectedInvoice.numeroFiche" (click)="deleteInoice()">
      <mat-icon>remove</mat-icon> Remove Invoice
    </button>

    <button mat-raised-button *ngIf=" selectedInvoice && selectedInvoice.dateenvoicontrat &&  selectedInvoice.aclasser  &&  selectedInvoice.numeroFiche && selectedInvoice.type!='Avoir'" (click)="avoirFactureSelected()">
      <mat-icon>edit</mat-icon> Facture d'avoir
    </button>

    <button mat-raised-button *ngIf=" selectedInvoice && !selectedInvoice.dateenvoicontrat &&  selectedInvoice.aclasser && selectedInvoice.type!='Avoir'" (click)="classerFacture(false)">
        <mat-icon>edit</mat-icon>Déverrouiler Facture
      </button>

      <button mat-raised-button *ngIf=" selectedInvoice && selectedInvoice.numeroFiche &&  !selectedInvoice.aclasser && selectedInvoice.type!='Avoir'" (click)="classerFacture(true)">
          <mat-icon>edit</mat-icon>Verrouiler Facture
        </button>
      
    <div class="mat-elevation-z8">
      <table mat-table [dataSource]="dataSource" style="width: 350px;">

        <!-- Position Column -->
        <ng-container matColumnDef="numeroFiche">
          <th mat-header-cell *matHeaderCellDef> No. </th>
          <td mat-cell *matCellDef="let element"> {{element.numeroFiche}} 
         
          </td>
        </ng-container>
 
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Invoice Date </th>
          <td mat-cell *matCellDef="let element"> {{element.datefacture | date}} </td>
        </ng-container>


        <ng-container matColumnDef="ttc">
          <th mat-header-cell *matHeaderCellDef>TTC </th>
          <td mat-cell *matCellDef="let element"> {{element.montantttc | currency: ' ' }} {{element.devise | uppercase}} </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="cursor: pointer;" (click)="selectRow(row)"
          [style.background]="row == selectedInvoice ? 'lightblue' : ''"></tr>
      </table>

    </div>
    <br />
    <br />
    <mat-list-item *ngFor="let pjoint of pjoints">
      <h6 mat-line> 
<span style="cursor: pointer;color: rgb(5, 112, 206);text-decoration: underline;" (click)="openPjoint(pjoint )">
 
{{pjoint.designation}}
</span>

        

 
</h6>
  <p mat-line> {{pjoint.taille}} </p>
 
</mat-list-item>
    <button *ngIf="false" mat-raised-button (click)="openContract()">
      <mat-icon>visibility</mat-icon>Show Contract
    </button>


    <button mat-raised-button *ngIf="zoomC==0.4 && fileURL" (click)="zoomContract(1)">
      <mat-icon>zoom_in</mat-icon>Zoom In
    </button>
    <button mat-raised-button *ngIf="zoomC==1 && fileURL" (click)="zoomContract(0.4)">
      <mat-icon>zoom_out</mat-icon>Zoom Out
    </button>


    <pdf-viewer [src]="fileURL" [zoom]="zoomC"></pdf-viewer>


  </mat-drawer>





  <mat-drawer-content>

    <button (click)="retour()" mat-icon-button>
      <mat-icon>keyboard_arrow_left </mat-icon> 
      Back
    </button>

    <mat-divider></mat-divider>
    <p></p>
    <div *ngIf="client">


      <h3 style="color: red">{{client.prospectId.raisonSocial}}</h3>

    </div>


    <app-edit-invoice  (valueChange)='updateInvoice($event)'></app-edit-invoice>









  </mat-drawer-content>
</mat-drawer-container>
</div>
<style>
     ::ng-deep #inparticipe .mat-card{
            padding: 20px!important;
            height: inherit!important;
        }
        ::ng-deep #inparticipe .mat-header-row{
        width: 100%!important;
        }

        
        #inparticipe{
          margin: 20px;
        }
        td{
          padding-right: 5px!important;
            padding-left: 5px!important;
          border-right: 0.5px rgb(187, 184, 184) solid;
        }
        th{
          text-align: center!important;
        }
        .mat-drawer.mat-drawer-side{
          z-index: 1!important;
        }

</style>